

import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { cleanNumericInput } from "../../../utils/income-utils";
import { TFieldValidationResult } from ".";
import { hasDefaultComponent } from "../../../utils/pageModelUtils";


export const incomeFieldValidations = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    const {
        monthlyIncome
    } = validatingState.getPersonalInformation();
    const {
        monthlyIncome: income
    } = validatingState.getPhoneAndIncomeInfo();
    const validationResult: TFieldValidationResult = {}

    if (
        hasDefaultComponent('cob-corp-acquisition/components/creditonebank/personal-information-form')
        || hasDefaultComponent('cob-corp-acquisition/components/creditonebank/phone-number-and-income')
    ) {
        if (
            !income
            || !monthlyIncome.value 
            || monthlyIncome.state === 'error'
            || cleanNumericInput(monthlyIncome.value).length < 3
        ) {
            validationResult['MonthlyIncome'] = 'RequiredField';
        }
    }

    return validationResult;
}